import createCache from '@emotion/cache';

export const myCache = createCache({
  key: 'my-prefix-key',
  prepend: true,
});